import { createUuid } from '@core/utils';

import type { MESSAGE_KEYWORD, MessageRequest } from './reserved-keywords';

type AppBridgeWindow = Window & {
  ReactNativeWebView?: {
    postMessage: (message: string) => void;
  };
  flutter_inappwebview?: {
    callHandler: (handlerName: string, message: string) => Promise<unknown>;
  };
  webkit?: {
    messageHandlers?: {
      'wello-channel'?: {
        postMessage: (message: string) => void;
      };
    };
  };
};

export const postAppMessage = (message: string) => {
  const _window = window as AppBridgeWindow;

  if (_window.ReactNativeWebView) {
    return _window.ReactNativeWebView.postMessage(message);
  }

  if (_window.flutter_inappwebview) {
    return _window.flutter_inappwebview.callHandler('wello-channel', message);
  }

  return _window.webkit?.messageHandlers?.['wello-channel']?.postMessage(
    message,
  );
};

export const hasReactNativeAppBridge = () => {
  if (typeof window === 'undefined') return false;

  return Boolean((window as AppBridgeWindow).ReactNativeWebView);
};

/**
 * 앱으로 단방향 메시지 송신 (응답 추적 없음).
 *
 * 고빈도 호출(예: 스크롤 중 좌표 갱신)이나 fire-and-forget 알림용.
 * 응답이 필요하면 useHandleApp 훅을 사용한다.
 */
export const sendAppMessage = (
  type: MESSAGE_KEYWORD,
  params?: MessageRequest['params'],
) => {
  if (typeof window === 'undefined') return;

  const reqParams = JSON.stringify({
    type,
    id: createUuid(),
    params,
  } satisfies MessageRequest);

  try {
    postAppMessage(reqParams);
  } catch (error) {
    console.error(error);
  }
};
